// Завдання 1
// Створити таймер, який буде починати відлік з 1 години та зменшувати час кожну хвилину. При досягненні 30 хвилин, таймер повинен відправляти повідомлення екран про те, що залишилось менше половини часу.
const timeEl = document.querySelector(".time");
let seconds = 3600;
let alertShown = false;
const hourTimerId = setInterval(()=>{
    seconds -= 60;
    timeEl.textContent = seconds;
    if (seconds <= 1800 && !alertShown) {
        alert("\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C \u043C\u0435\u043D\u0448\u0435 \u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0438 \u0447\u0430\u0441\u0443!");
        alertShown = true;
    }
    if (seconds <= 0) {
        clearInterval(hourTimerId);
        timeEl.textContent = 0;
    }
}, 3600);
// =================================================================================
// Завдання 2
// Створити таймер, який буде починати відлік з 30 секунд та зменшувати час кожну мілісекунду. При досягненні 10 секунд, таймер повинен відтворювати якусь анімацію, а при досягненні 0 секунд — виконувати певну дію, наприклад, робити кнопку почати знову активною.
const timeMsEl = document.querySelector(".timeMs");
const timerMsEl = document.querySelector(".timer-ms");
const btnEl = document.querySelector(".btn");
let secondTimer = 30000;
let msTimerId;
btnEl.disabled = true;
function startTimer() {
    btnEl.disabled = true;
    secondTimer = 30000;
    msTimerId = setInterval(()=>{
        secondTimer--;
        timeMsEl.textContent = (secondTimer / 1000).toFixed(3);
        if (secondTimer <= 10000) timerMsEl.classList.add("active");
        if (secondTimer <= 0) {
            clearInterval(msTimerId);
            btnEl.disabled = false;
        }
    }, 1);
}
startTimer();
btnEl.addEventListener("click", ()=>{
    timerMsEl.classList.remove("active");
    startTimer();
});

//# sourceMappingURL=goit-tema11.f89a3689.js.map
